const MODULE_PATIENT = "patient";
const MODULE_CLIENT = "client";
const MODULE_CONTACT = "contact"; // general for contact
const MODULE_CONTACT_COMPANY = "contact_company"; // for contact company
const RESEND_COMMUNICATION = "resent_communication"; // for resend communication

const RTYPE = {
    [MODULE_PATIENT]: "patient",
    [MODULE_CLIENT]: "client",
    [MODULE_CONTACT]: "contact"
};

const MODULE_ID = {
    [MODULE_PATIENT]: 1,
    [MODULE_CLIENT]: 2,
    [MODULE_CONTACT]: 3,
    [MODULE_CONTACT_COMPANY]: 4
};

const REFERENCE_TYPE = {
    [MODULE_CLIENT]: 6,
    [MODULE_CONTACT]: 17,
    [RESEND_COMMUNICATION]: 21
};

export default {
    MODULE_PATIENT,
    MODULE_CLIENT,
    MODULE_CONTACT,
    MODULE_CONTACT_COMPANY,
    RTYPE,
    MODULE_ID,
    REFERENCE_TYPE
};
